import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManure = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.168 13.2535C10.3534 12.9753 10.6656 12.8082 11 12.8082H13C13.3344 12.8082 13.6466 12.9753 13.8321 13.2535L14.5352 14.3082H16C16.3148 14.3082 16.6111 14.4564 16.8 14.7082L18.1126 16.4583L19.3162 16.8595C19.5678 16.9433 19.7758 17.1237 19.8944 17.361L20.8944 19.361C21.0494 19.6709 21.0329 20.0391 20.8507 20.3339C20.6684 20.6287 20.3466 20.8082 20 20.8082H4C3.65342 20.8082 3.33156 20.6287 3.14935 20.3339C2.96714 20.0391 2.95058 19.6709 3.10557 19.361L4.10557 17.361C4.22418 17.1237 4.43217 16.9433 4.68377 16.8595L5.88743 16.4583L7.2 14.7082C7.38886 14.4564 7.68524 14.3082 8 14.3082H9.46482L10.168 13.2535ZM11.5352 14.8082L10.8321 15.8629C10.6466 16.1411 10.3344 16.3082 10 16.3082H8.5L7.3 17.9082C7.17796 18.0709 7.0092 18.1925 6.81623 18.2568L5.70919 18.6259L5.61804 18.8082H18.382L18.2908 18.6259L17.1838 18.2568C16.9908 18.1925 16.822 18.0709 16.7 17.9082L15.5 16.3082H14C13.6656 16.3082 13.3534 16.1411 13.168 15.8629L12.4648 14.8082H11.5352Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.1244 5.91374C7.61838 6.16073 7.8186 6.7614 7.57161 7.25538L7.20407 7.99047C7.01887 8.36087 7.09146 8.80823 7.38429 9.10106C8.28584 10.0026 8.50935 11.3799 7.93916 12.5203L7.57161 13.2554C7.32462 13.7494 6.72395 13.9496 6.22997 13.7026C5.73599 13.4556 5.53577 12.8549 5.78276 12.361L6.1503 11.6259C6.33551 11.2555 6.26291 10.8081 5.97008 10.5153C5.06853 9.61372 4.84502 8.23642 5.41521 7.09604L5.78276 6.36095C6.02975 5.86697 6.63042 5.66675 7.1244 5.91374Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.8634 5.91374C18.3574 6.16073 18.5576 6.7614 18.3106 7.25538L17.9431 7.99047C17.7579 8.36087 17.8304 8.80823 18.1233 9.10106C19.0248 10.0026 19.2483 11.3799 18.6781 12.5203L18.3106 13.2554C18.0636 13.7494 17.4629 13.9496 16.969 13.7026C16.475 13.4556 16.2748 12.8549 16.5217 12.361L16.8893 11.6259C17.0745 11.2555 17.0019 10.8081 16.7091 10.5153C15.8075 9.61372 15.584 8.23642 16.1542 7.09604L16.5217 6.36095C16.7687 5.86697 17.3694 5.66675 17.8634 5.91374Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.6 5.00816C13.0418 5.33954 13.1314 5.96634 12.8 6.40816L12.5211 6.78002C12.4739 6.84291 12.4893 6.93251 12.5547 6.97611C13.5754 7.65661 13.815 9.05489 13.0789 10.0363L12.8 10.4082C12.4686 10.85 11.8418 10.9395 11.4 10.6082C10.9582 10.2768 10.8686 9.64999 11.2 9.20816L11.4789 8.83631C11.5261 8.77342 11.5107 8.68382 11.4453 8.64021C10.4246 7.95972 10.185 6.56144 10.9211 5.58002L11.2 5.20816C11.5314 4.76634 12.1582 4.67679 12.6 5.00816Z",
			fill: "currentColor"
		})
	]
});
export default SvgManure;
